import { createApi } from '@reduxjs/toolkit/query/react';

import { Avatar, Org, SupplierStatusFlags } from '@scaleup/models';
import { baseQuery } from './baseQuery';
import { TagTypes } from './tagTypes';

export const org = createApi({
  reducerPath: 'org',
  baseQuery: baseQuery,
  tagTypes: [TagTypes.avatar, TagTypes.org],
  endpoints: (builder) => ({
    getPresignedUrl: builder.mutation<
      { presignedUrl: string },
      { contentType: string; fileName: string }
    >({
      query: ({ contentType, fileName }) => ({
        url: `/org_doc?content_type=${contentType}&file_name=${fileName}`,
        method: 'POST',
      }),
    }),
    getOrgProfileImage: builder.query<Avatar, string>({
      query: (orgId) => `/avatar/${orgId}`,
      providesTags: (result, error, id) => [{ type: TagTypes.avatar, id }],
    }),
    getOrg: builder.query<Org, void>({
      query: () => `/org`,
      providesTags: [TagTypes.org],
    }),
    updateOrg: builder.mutation<Org, Org>({
      query: (org) => ({
        url: `/org`,
        method: 'PUT',
        body: org,
      }),
      invalidatesTags: [TagTypes.org],
    }),
    updateSupplierStatusFlags: builder.mutation<void, SupplierStatusFlags>({
      query: (flags) => ({
        url: `/org/flags`,
        method: 'PUT',
        body: flags,
      }),
      invalidatesTags: [TagTypes.org],
    }),
  }),
});

export const {
  useGetPresignedUrlMutation,
  useGetOrgQuery,
  useGetOrgProfileImageQuery,
  useUpdateOrgMutation,
  useUpdateSupplierStatusFlagsMutation,
} = org;
